
import React, { useState, useEffect, useLayoutEffect, ChangeEvent, useCallback } from "react";
// import axios from "axios";

// interface WithdrawRequest {
//   _id: string;
//   email: string;
//   amount: string;
//   address: string;
//   status: string;
//   createdAt: string;
// }

// const Withdraw: React.FC = () => {
//   const [withdrawData, setWithdrawData] = useState<WithdrawRequest[]>([]);
//   const [filteredWithdrawData, setFilteredWithdrawData] = useState<WithdrawRequest[]>([]);
//   const [searchTerm, setSearchTerm] = useState<string>("");
//   const [statusFilter, setStatusFilter] = useState<string>("All");
//   const [loading, setLoading] = useState<boolean>(false);
//   const [activeActionId, setActiveActionId] = useState<string | null>(null);

//   // Fetch withdraw data
//   const fetchWithdrawData = async (): Promise<void> => {
//     try {
//       const response = await axios.get(`${API_BASE}/api/withdraw/getWithdraw`);
//       const withdraw: WithdrawRequest[] = Object.values(response.data.Withdraw) as WithdrawRequest[];
// withdraw.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

//       setWithdrawData(withdraw);
//       setFilteredWithdrawData(withdraw);
//     } catch (error) {
//       console.error("Error fetching withdraw data: ", error);
//     }
//   };

//   useEffect(() => {
//     fetchWithdrawData();
//   }, []);

//   // Search & Filter Logic
//   useEffect(() => {
//     let filtered = withdrawData;

//     if (searchTerm) {
//       filtered = filtered.filter((request) =>
//         request.email.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }

//     if (statusFilter !== "All") {
//       filtered = filtered.filter((request) => request.status.toLowerCase() === statusFilter.toLowerCase());
//     }

//     setFilteredWithdrawData(filtered);
//   }, [searchTerm, statusFilter, withdrawData]);

//   const handleSearchChange = (event: ChangeEvent<HTMLInputElement>): void => {
//     setSearchTerm(event.target.value);
//   };

//   const handleStatusFilterChange = (event: ChangeEvent<HTMLSelectElement>): void => {
//     setStatusFilter(event.target.value);
//   };

//   const handleAction = async (actionType: "approve" | "reject", id: string, email: string, amount?: string): Promise<void> => {
//     setLoading(true);
//     setActiveActionId(id);

//     try {
//       if (actionType === "reject" && amount) {
//         const updatedWalletResponse = await axios.get(`${API_BASE}/api/wallet/walletbalance/${email}`);
//         const walletAmount: string = updatedWalletResponse.data.wallet.balance;
//         const finalAmount = parseFloat(walletAmount) + parseFloat(amount);

//         await axios.post(`${API_BASE}/api/wallet/updateWallet`, {
//           email: email,
//           amount: finalAmount.toString(),
//         });

//         await axios.post(`${API_BASE}/api/withdraw/updateWithdraw/${id}`, {
//           email: email,
//           withdrawStatus: "rejected",
//         });
//       } else if (actionType === "approve") {
//         await axios.post(`${API_BASE}/api/withdraw/updateWithdraw/${id}`, {
//           email: email,
//           withdrawStatus: "Success",
//         });
//       }

//       await fetchWithdrawData();
//     } catch (error) {
//       console.error(`Error during ${actionType} operation: `, error);
//     } finally {
//       setLoading(false);
//       setActiveActionId(null);
//     }
//   };

//   return (
//     <div className="max-w-6xl mx-auto p-8">
//       <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Withdrawal Requests</h1>

//       {/* Search & Filter Controls */}
//       <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
//         <input
//           type="text"
//           placeholder="Search by Email..."
//           className="border rounded-lg p-3 w-full md:w-1/2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//           value={searchTerm}
//           onChange={handleSearchChange}
//         />

//         <select
//           className="border rounded-lg p-3 w-full md:w-1/4 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//           value={statusFilter}
//           onChange={handleStatusFilterChange}
//         >
//           <option value="All">All</option>
//           <option value="Pending">Pending</option>
//           <option value="Success">Success</option>
//           <option value="Rejected">Rejected</option>
//         </select>
//       </div>

//       {/* Withdraw Requests List */}
//       <div className="space-y-6">
//         {filteredWithdrawData.length > 0 ? (
//           filteredWithdrawData.map((request: any, index: number) => (
//             <div key={index} className="bg-white shadow-lg rounded-xl p-6 border border-gray-200 w-full">
//               <div className="flex justify-between items-center mb-2">
//                 <h2 className="text-lg font-semibold text-gray-800">{request.email}</h2>
//                 <span
//                   className={`px-3 py-1 rounded-full text-xs font-semibold ${
//                     request.status.toLowerCase() === "success"
//                       ? "bg-green-100 text-green-700"
//                       : request.status.toLowerCase() === "pending"
//                       ? "bg-yellow-100 text-yellow-700"
//                       : "bg-red-100 text-red-700"
//                   }`}
//                 >
//                   {request.status}
//                 </span>
//               </div>

//               <div className="mt-3">
//                 <p className="text-gray-600">
//                   <strong>Amount:</strong> <span className="text-green-600 font-bold">${request.amount}</span>
//                 </p>
//                 <p className="text-gray-600">
//                   <strong>Time:</strong> {new Date(request.createdAt).toLocaleString()}
//                 </p>
//                 <p className="text-gray-600">
//                   <strong>Address:</strong> {request.address}
//                   <button
//                     onClick={() => navigator.clipboard.writeText(request.address)}
//                     className="ml-2 text-xs bg-blue-500 hover:bg-blue-700 text-white font-light py-[2px] px-2 rounded"
//                   >
//                     Copy
//                   </button>
//                 </p>
//               </div>

//               {/* Action Buttons */}
//               {request.status === "Pending" && (
//                 <div className="mt-4 flex space-x-4">
//                   <button
//                     onClick={() => handleAction("approve", request._id, request.email)}
//                     disabled={loading && activeActionId === request._id}
//                     className="text-white bg-green-500 hover:bg-green-600 px-4 py-2 rounded"
//                   >
//                     {loading && activeActionId === request._id ? "Loading..." : "Approve"}
//                   </button>
//                   <button
//                     onClick={() => handleAction("reject", request._id, request.email, request.amount)}
//                     disabled={loading && activeActionId === request._id}
//                     className="text-white bg-red-500 hover:bg-red-600 px-4 py-2 rounded"
//                   >
//                     {loading && activeActionId === request._id ? "Loading..." : "Reject"}
//                   </button>
//                 </div>
//               )}
//             </div>
//           ))
//         ) : (
//           <p className="text-gray-500 text-center">No withdrawals found.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Withdraw;
import api from "../utils/api";

interface WithdrawRequest {
  _id: string;
  email: string;
  amount: string;
  address: string;
  status: string;
  createdAt: string;
}

const Withdraw: React.FC = () => {
  const [withdrawData, setWithdrawData] = useState<WithdrawRequest[]>([]);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState<string>("All");
  const [loading, setLoading] = useState<boolean>(false);
  const [activeActionId, setActiveActionId] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [withdrawalFee, setWithdrawalFee] = useState<number>(4);

  useEffect(() => {
    const t = window.setTimeout(() => setSearch(searchInput.trim()), 400);
    return () => window.clearTimeout(t);
  }, [searchInput]);

  useLayoutEffect(() => {
    setPage(1);
  }, [search, statusFilter, limit]);

  const fetchRules = async () => {
    try {
      const response = await api.get('/api/business-rules');
      if (response.data.status === 'success') {
        const feeRule = response.data.data.find((r: any) => r.key === 'WITHDRAWAL_FEE_PERCENTAGE');
        if (feeRule) setWithdrawalFee(Number(feeRule.value));
      }
    } catch (error) {
      console.error("Error fetching rules:", error);
    }
  };

  const fetchWithdrawData = useCallback(async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        search,
        status: statusFilter,
      });
      const response = await api.get(`/api/withdraw/getWithdraw?${params.toString()}`);
      if (response.data.status === "success") {
        const withdrawals = response.data.withdrawals || (response.data.Withdraw ? Object.values(response.data.Withdraw) : []);
        setWithdrawData(withdrawals);
        const p = response.data.pagination;
        if (p) {
          setTotal(p.total ?? 0);
          setTotalPages(Math.max(0, p.totalPages ?? 0));
        }
      }
    } catch (error) {
      console.error("Error fetching withdraw data: ", error);
      setWithdrawData([]);
    } finally {
      setLoading(false);
    }
  }, [page, limit, search, statusFilter]);

  useEffect(() => {
    fetchWithdrawData();
  }, [fetchWithdrawData]);

  useEffect(() => {
    fetchRules();
  }, []);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setSearchInput(event.target.value);
  };

  const handleStatusFilterChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    setStatusFilter(event.target.value);
  };

  const handleAction = async (actionType: "approve" | "reject", id: string, email: string): Promise<void> => {
    const status = actionType === "approve" ? "Success" : "rejected";
    if (!window.confirm(`Are you sure you want to ${actionType} this withdrawal?`)) return;

    setLoading(true);
    setActiveActionId(id);

    try {
      await api.post(`/api/withdraw/updateWithdraw/${id}`, {
        email: email,
        withdrawStatus: status,
      });

      alert(`Withdrawal ${actionType}ed successfully`);
      await fetchWithdrawData();
    } catch (error) {
      console.error(`Error during ${actionType} operation: `, error);
      alert(`Failed to ${actionType} withdrawal`);
    } finally {
      setLoading(false);
      setActiveActionId(null);
    }
  };

  return (
    <div className="max-w-6xl mx-auto p-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Withdrawal Requests</h1>

      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
        <input
          type="text"
          placeholder="Search by Email..."
          className="border rounded-lg p-3 w-full md:w-1/2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={searchInput}
          onChange={handleSearchChange}
        />

        <div className="flex gap-2 w-full md:w-auto">
          <select
            className="border rounded-lg p-3 flex-grow md:flex-none md:w-40 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={statusFilter}
            onChange={handleStatusFilterChange}
          >
            <option value="All">All Status</option>
            <option value="Pending">Pending</option>
            <option value="Success">Success</option>
            <option value="Rejected">Rejected</option>
          </select>

          <select
            value={limit}
            onChange={(e) => {
              setLimit(parseInt(e.target.value, 10));
            }}
            className="p-3 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-300"
          >
            <option value="10">10 / page</option>
            <option value="20">20 / page</option>
            <option value="50">50 / page</option>
            <option value="100">100 / page</option>
          </select>
        </div>
      </div>

      {/* Withdraw Requests List */}
      <div className="space-y-6">
        {withdrawData.length > 0 ? (
          withdrawData.map((request: any, index: number) => (
            <div key={index} className="bg-white shadow-lg rounded-xl p-4 md:p-6 border border-gray-200 w-full hover:shadow-xl transition-shadow">
              <div className="flex justify-between items-start mb-4">
                <div className="min-w-0 flex-1">
                  <h2 className="text-sm md:text-lg font-bold text-gray-800 truncate">{request.email}</h2>
                  <p className="text-[10px] md:hidden text-gray-400 mt-0.5">{new Date(request.createdAt).toLocaleString('en-GB')}</p>
                </div>
                <span
                  className={`shrink-0 px-2 md:px-3 py-0.5 md:py-1 rounded-full text-[10px] md:text-xs font-bold uppercase tracking-tight ${request.status.toLowerCase() === "success"
                    ? "bg-green-100 text-green-700"
                    : request.status.toLowerCase() === "pending"
                      ? "bg-yellow-100 text-yellow-700"
                      : "bg-red-100 text-red-700"
                    }`}
                >
                  {request.status}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-y-3 gap-x-4 md:flex md:flex-col md:gap-1 text-xs md:text-sm">
                <div className="flex flex-col md:flex-row md:gap-2 gap-0.5">
                  <span className="text-[9px] md:text-sm text-gray-400 md:text-gray-600 font-bold md:font-semibold uppercase md:capitalize">Original</span>
                  <span className="text-gray-700 md:text-gray-600 font-medium md:font-bold">
                    {isNaN(parseFloat(request.amount)) ? "Invalid" : `$${(parseFloat(request.amount)).toFixed(2)}`}
                  </span>
                </div>
                <div className="flex flex-col md:flex-row md:gap-2 gap-0.5">
                  <span className="text-[9px] md:text-sm text-gray-400 md:text-gray-600 font-bold md:font-semibold uppercase md:capitalize">Net Payout <span className="md:hidden">(-{withdrawalFee}%)</span></span>
                  <span className="text-green-600 font-black">
                    {isNaN(parseFloat(request.amount)) ? "Invalid" : `$${(parseFloat(request.amount) * (1 - withdrawalFee / 100)).toFixed(2)}`}
                  </span>
                </div>
                <div className="hidden md:block">
                  <p className="text-gray-600">
                    <strong>Time:</strong> {new Date(request.createdAt).toLocaleString('en-GB')}
                  </p>
                </div>
                <div className="col-span-2 flex flex-col md:flex-row md:items-center gap-1">
                  <span className="text-[9px] md:text-sm text-gray-400 md:text-gray-600 font-bold md:font-semibold uppercase md:capitalize">Address</span>
                  <div className="flex items-center gap-2 overflow-hidden">
                    <span className="text-gray-600 truncate flex-1 font-medium">{request.address}</span>
                    <button
                      onClick={() => navigator.clipboard.writeText(request.address)}
                      className="shrink-0 px-2 py-0.5 bg-blue-500 text-white rounded text-[8px] md:text-xs font-bold"
                    >
                      Copy
                    </button>
                  </div>
                </div>
              </div>
              <p className="text-[9px] md:text-sm text-gray-500 mt-2 italic font-medium">
                * {withdrawalFee}% fee deducted from original amount
              </p>

              {/* Action Buttons */}
              {request.status === "Pending" && (
                <div className="mt-4 flex space-x-4">
                  <button
                    onClick={() => handleAction("approve", request._id, request.email)}
                    disabled={loading && activeActionId === request._id}
                    className="text-white bg-green-500 hover:bg-green-600 px-4 py-2 rounded"
                  >
                    {loading && activeActionId === request._id ? "Loading..." : "Approve"}
                  </button>
                  <button
                    onClick={() => handleAction("reject", request._id, request.email)}
                    disabled={loading && activeActionId === request._id}
                    className="text-white bg-red-500 hover:bg-red-600 px-4 py-2 rounded"
                  >
                    {loading && activeActionId === request._id ? "Loading..." : "Reject"}
                  </button>
                </div>
              )}
            </div>
          ))
        ) : (
          <p className="text-gray-500 text-center">No withdrawals found.</p>
        )}
      </div>

      {/* Advanced Pagination Controls */}
      {!loading && withdrawData.length > 0 && total > 0 && (
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 mt-8 mb-4">
          <div className="flex items-center space-x-2">
            <button
              type="button"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page <= 1}
              className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 disabled:opacity-50 transition-colors font-medium text-gray-700"
            >
              Previous
            </button>

            <div className="flex items-center space-x-1">
              {(() => {
                const pages = [];
                const maxVisible = 5;
                const safeTp = Math.max(1, totalPages || 1);
                let start = Math.max(1, page - Math.floor(maxVisible / 2));
                let end = Math.min(safeTp, start + maxVisible - 1);

                if (end - start + 1 < maxVisible) {
                  start = Math.max(1, end - maxVisible + 1);
                }

                if (start > 1) {
                  pages.push(
                    <button
                      type="button"
                      key={1}
                      onClick={() => setPage(1)}
                      className="w-10 h-10 rounded-lg border hover:bg-gray-50 transition-colors text-gray-600"
                    >
                      1
                    </button>
                  );
                  if (start > 2) pages.push(<span key="dots-start" className="px-1 text-gray-400">...</span>);
                }

                for (let i = start; i <= end; i++) {
                  if (i <= 0) continue;
                  pages.push(
                    <button
                      type="button"
                      key={i}
                      onClick={() => setPage(i)}
                      className={`w-10 h-10 rounded-lg border transition-all ${page === i
                        ? "bg-blue-600 text-white border-blue-600 shadow-md transform scale-105"
                        : "hover:bg-gray-50 text-gray-700"
                        }`}
                    >
                      {i}
                    </button>
                  );
                }

                if (end < safeTp) {
                  if (end < safeTp - 1) pages.push(<span key="dots-end" className="px-1 text-gray-400">...</span>);
                  pages.push(
                    <button
                      type="button"
                      key={safeTp}
                      onClick={() => setPage(safeTp)}
                      className="w-10 h-10 rounded-lg border hover:bg-gray-50 transition-colors text-gray-600"
                    >
                      {safeTp}
                    </button>
                  );
                }

                return pages;
              })()}
            </div>

            <button
              type="button"
              onClick={() => setPage((p) => Math.min(Math.max(1, totalPages || 1), p + 1))}
              disabled={page >= Math.max(1, totalPages || 1)}
              className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 disabled:opacity-50 transition-colors font-medium text-gray-700"
            >
              Next
            </button>
          </div>

          <div className="flex items-center space-x-2 text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-lg border shadow-sm">
            <span>Go to:</span>
            <input
              type="number"
              min="1"
              max={Math.max(1, totalPages || 1)}
              className="w-16 p-1 border rounded text-center focus:ring focus:ring-blue-100 outline-none"
              placeholder="#"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const p = parseInt((e.target as HTMLInputElement).value, 10);
                  const maxP = Math.max(1, totalPages || 1);
                  if (!isNaN(p) && p >= 1 && p <= maxP) {
                    setPage(p);
                  }
                }
              }}
            />
            <span className="whitespace-nowrap">of {Math.max(1, totalPages || 1)} ({total} total)</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Withdraw;